import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
type Purchase = {
  name: string;
  city: string;
  flag: string;
  action: string;
  minutes: number;
};
const PURCHASES: Purchase[] = [{
  name: 'Valentina M.',
  city: 'Buenos Aires',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 3
}, {
  name: 'Martín G.',
  city: 'Córdoba',
  flag: '🇦🇷',
  action: 'se sumó al sistema',
  minutes: 7
}, {
  name: 'Carolina R.',
  city: 'Rosario',
  flag: '🇦🇷',
  action: 'acaba de acceder al Master Kit',
  minutes: 1
}, {
  name: 'Diego F.',
  city: 'Mendoza',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 2
}, {
  name: 'Luciana P.',
  city: 'La Plata',
  flag: '🇦🇷',
  action: 'se sumó',
  minutes: 11
}, {
  name: 'Sebastián T.',
  city: 'Mar del Plata',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 5
}, {
  name: 'Valeria H.',
  city: 'Tucumán',
  flag: '🇦🇷',
  action: 'acaba de descargar el sistema',
  minutes: 1
}, {
  name: 'Nicolás B.',
  city: 'Salta',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 4
}, {
  name: 'Florencia K.',
  city: 'Santa Fe',
  flag: '🇦🇷',
  action: 'se sumó',
  minutes: 9
}, {
  name: 'Gonzalo W.',
  city: 'Mendoza',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 6
}, {
  name: 'Romina S.',
  city: 'CABA',
  flag: '🇦🇷',
  action: 'acaba de acceder',
  minutes: 1
}, {
  name: 'Facundo L.',
  city: 'Córdoba',
  flag: '🇦🇷',
  action: 'se sumó',
  minutes: 18
}, {
  name: 'Agustina C.',
  city: 'Rosario',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 13
}, {
  name: 'Hernán D.',
  city: 'Buenos Aires',
  flag: '🇦🇷',
  action: 'se sumó',
  minutes: 3
}, {
  name: 'Jimena V.',
  city: 'Mar del Plata',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 16
}, {
  name: 'Florencia B.',
  city: 'Neuquén',
  flag: '🇦🇷',
  action: 'se sumó',
  minutes: 8
}, {
  name: 'Cecilia M.',
  city: 'San Juan',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 21
}, {
  name: 'Ramiro T.',
  city: 'Entre Ríos',
  flag: '🇦🇷',
  action: 'se sumó',
  minutes: 10
}, {
  name: 'Gabriela S.',
  city: 'Misiones',
  flag: '🇦🇷',
  action: 'acaba de acceder al sistema',
  minutes: 1
}, {
  name: 'Lucas P.',
  city: 'San Luis',
  flag: '🇦🇷',
  action: 'compró el Kit',
  minutes: 15
}];
const getInitials = (name: string) => name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
const SHOW_INTERVAL = 15000; // cada 15 segundos
const VISIBLE_DURATION = 4000; // permanece 4 segundos
export const SocialProofPopup = () => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const showNext = () => {
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), VISIBLE_DURATION);
    };
    // Primer popup a los 4s de cargar la página
    const firstTimer = setTimeout(showNext, 4000);
    const cycleTimer = setInterval(() => {
      setIndex(prev => (prev + 1) % PURCHASES.length);
      showNext();
    }, SHOW_INTERVAL);
    return () => {
      clearTimeout(firstTimer);
      clearTimeout(hideTimer);
      clearInterval(cycleTimer);
    };
  }, []);
  const p = PURCHASES[index];
  return <div className="fixed top-3 right-3 z-[60] pointer-events-none" data-id="element-234" data-mp="3uc9j67f5auk9">
      <AnimatePresence mode="wait" data-id="element-235" data-mp="vtb34h0ndtk4">
        {visible && <motion.div key={index} initial={{
        opacity: 0,
        x: 40,
        y: -8
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: 40,
        y: -8
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} role="status" aria-live="polite" className="pointer-events-auto w-[268px] sm:w-[300px] bg-familia-darkCard border border-familia-darkBorder rounded-2xl shadow-md md:shadow-[0_10px_30px_-8px_rgba(0,0,0,0.5)] px-3 py-3" data-id="element-236" data-mp="vt2pgmwpak7v">
            <div className="flex items-start gap-3" data-id="element-237" data-mp="ubcgmqxebnbx">
              {/* Avatar con bandera */}
              <div className="relative shrink-0" data-id="element-238" data-mp="z22ivvaiza2e">
                <div className="w-11 h-11 rounded-full bg-familia-gold text-familia-bg flex items-center justify-center font-bold text-sm" data-id="element-239" data-mp="z2uh7dviblwd">
                  {getInitials(p.name)}
                </div>
                <span className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-familia-card border border-white/10 flex items-center justify-center text-[11px] leading-none" data-id="element-240" data-mp="pd15mcvd76s4">
                  {p.flag}
                </span>
              </div>

              {/* Contenido */}
              <div className="flex-1 min-w-0" data-id="element-241" data-mp="132mfmxr6sbo0">
                <div className="flex items-center gap-1.5 text-familia-gray text-[11px] mb-0.5" data-id="element-242" data-mp="135qv4ra3qttz">
                  <span className="text-[12px] leading-none" data-id="element-243" data-mp="184tv3xb869v3">{p.flag}</span>
                  <span className="truncate" data-id="element-244" data-mp="3nsbv9czps1hr">{p.city}</span>
                </div>
                <p className="text-white text-[12px] leading-snug" data-id="element-245" data-mp="3su13ylzgs32o">
                  <span className="font-bold" data-id="element-246" data-mp="2av37wjnbkbdr">{p.name}</span> {p.action}
                </p>
                <div className="flex items-center gap-1.5 mt-1 text-familia-gold text-[11px] font-semibold" data-id="element-247" data-mp="25w8njd9peerj">
                  <ShoppingBagIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-248" data-mp="2jwjiare4wdhz" />
                  <span data-id="element-249" data-mp="2fug59ybth0ul">Compra verificada</span>
                  <span className="text-familia-onDarkMuted" data-id="element-250" data-mp="2fvr89vxfu4kn">
                    • hace {p.minutes} minutos
                  </span>
                </div>
              </div>

              {/* Cerrar */}
              <button type="button" onClick={() => setVisible(false)} aria-label="Cerrar notificación" className="shrink-0 text-familia-gray hover:text-white transition-colors" data-id="element-251" data-mp="1n721phdm571i">
                <XIcon className="w-4 h-4" data-id="element-252" data-mp="1w66zglhcowcm" />
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};